import React from 'react';
import {ExpandableText} from '../../../../components/expandable-text';

interface CandidateNoteBannerProps {
  note: string;
}

export const CandidateNoteBanner: React.FC<CandidateNoteBannerProps> = ({note}) => {
  if (!note?.trim()) return null;

  return (
    <div className="mb-4 flex items-start gap-3 rounded-xl bg-blue-50 border border-blue-100 px-4 py-3">
      <svg className="w-5 h-5 mt-0.5 shrink-0 text-blue-500" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
        <path d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z" />
      </svg>
      <div className="min-w-0">
        <div className="text-sm font-semibold text-zinc-900">Note from the candidate</div>
        <ExpandableText maxLength={220} className="text-sm text-zinc-700 leading-relaxed">
          {note.trim()}
        </ExpandableText>
      </div>
    </div>
  );
};
